import React, { useState, useEffect, use } from 'react';
import '../css/Admin/Profile.css'
import ProfileImg from '../assets/profile_img.png';
import ResponseMsg from '../general/ResponseMsg';
import Loading from '../general/Loading';
import { useNavigate } from 'react-router-dom';

const Profile = ({ userData, isAdmin, isSubAdmin, isDeliveryAgent, isUser }) => {
    const [response, setResponse] = useState(null);
    const navigate = useNavigate();
    const [showOffer, setShowOffer] = useState(false);
    const [showEditOffer, setShowEditOffer] = useState(false);
    const [selectedOffer, setSelectedOffer] = useState('');
    const [showProfile, setShowProfile] = useState(true);
    const [showAddress, setShowAddress] = useState(false);
    const [showManage, setShowManage] = useState(false);
    const [showPlatformFee, setShowPlatformFee] = useState(false);
   const [loading, setLoading] = useState(false);
  const [showPass, setShowPass] = useState(false);


    const [offers, setOffers] = useState([]);
    const [offerData, setOfferData] = useState({
        offerName: '',
        offerTagline: '',
        offerImage: null,
        description: ''
    });

    const [formData, setFormData] = useState({
        name: '',
        phone: '',
        email: '',
        gender: '',
        location: '',
        city: '',
        state: '',
        pincode: '',
        pass: '',
    });


    const [feeData, setFeeData] = useState({
        platform_fee: '',
        delivery_fee: '',
        qrCode: '',
    });


    useEffect(() => {
        const fetchUserData = async () => {
            setLoading(true);
            try {
                const response = await fetch(`https://api.kcmstore.in/store/users/${userData.id}?checkMobile=${userData.phone}&checkPassword=${userData.pass}`);

                setLoading(false);
                if (response.ok) {
                    const data = await response.json();
                    setFormData({
                        name: data.name || '',
                        phone: data.phone || '',
                        email: data.email || '',
                        gender: data.gender || '',
                        location: data.location || data.address || '',
                        city: data.city || '',
                        state: data.state || '',
                        pincode: data.pincode || '',
                        pass: data.pass || '',
                    });
                    setFeeData({
                        platform_fee: data.platform_fee || '',
                        delivery_fee: data.delivery_fee || '',
                    })
                } else {
                    console.error('Failed to fetch user data');
                    setLoading(false);
                }
            } catch (error) {
                console.error('Error fetching user data:', error);
                setLoading(false);
            }
        };

        fetchUserData();
    }, [userData.id]);

    useEffect(() => {
        const fetchOffers = async () => {
            try {
                const response = await fetch('https://api.kcmstore.in/store/get-offers');
                if (response.ok) {
                    const data = await response.json();
                    setOffers(data);
                } else {
                    console.error('Failed to fetch offers');
                }
            } catch (error) {
                console.error('Error fetching offers:', error);
            }
        };

        fetchOffers();
    }, []);

    // Handle form field changes
    const handleChange = (e) => {
        const { id, value } = e.target;
        setFormData({
            ...formData,
            [id]: value
        });
    };


        const handleFeeChange = (e) => {
        const { id, value } = e.target;
        setFeeData({
            ...feeData,
            [id]: value
        });
    };

    // Handle form submission (update profile)
    const handleSubmit = async (e) => {
        e.preventDefault();
        let api;
        setLoading(true);

        try {
            if (isAdmin || isUser) {
                api = `https://api.kcmstore.in/store/update-profile/${userData.id}`
            }
            else if (isSubAdmin) {
                api = `https://api.kcmstore.in/store/update-subadmin-profile/${userData.id}`
            }
            else if (isDeliveryAgent) {
                api = `https://api.kcmstore.in/store/update-deliveryagent-profile/${userData.id}`
            };

            const response = await fetch(api, {
                method: 'PUT',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(formData)
            });

            setLoading(false);
            const result = await response.json();
            if (response.ok) {
                localStorage.setItem('userData', JSON.stringify(result));
                console.log(result);
                setResponse('Profile updated successfully!');
                setTimeout(() => {
                    setResponse('');
                    window.location.reload();
                }, 2000);
            } else {
                setLoading(false);
                setResponse('Failed to update profile.');
                setTimeout(() => {
                    setResponse('');
                }, 2000);
            }
        } catch (error) {
            setLoading(false);
            console.error('Error updating profile:', error);
        }
    };


        const handleFeeSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        try {
 const formData = new FormData();
    formData.append("platform_fee", feeData.platform_fee);
    formData.append("delivery_fee", feeData.delivery_fee);
    formData.append("qrCode", feeData.qrCode);


            const response = await fetch(`https://api.kcmstore.in/store/update-fee/${userData.id}`, {
                method: 'PUT',
             
                body: formData
            });

            setLoading(false);
            const result = await response.json();
            if (response.ok) {
                localStorage.setItem('userData', JSON.stringify(result));
                console.log(result);
                setResponse('Fee updated successfully!');
                setTimeout(() => {
                    setResponse('');
                    window.location.reload();
                }, 2000);
            } else {
                setLoading(false);
                setResponse('Failed to update Fee.');
                setTimeout(() => {
                    setResponse('');
                }, 2000);
            }
        } catch (error) {
            setLoading(false);
            console.error('Error updating fee:', error);
        }
    };


    const handleOfferChange = (e) => {
        const { id, value, type, files } = e.target;
        if (type === 'file') {
            setOfferData({
                ...offerData,
                [id]: files[0]
            });
        } else {
            setOfferData({
                ...offerData,
                [id]: value
            });
        }
    };


    const handleOfferSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        // Create a FormData object to send the offer data (including the image file)
        const formData = new FormData();
        formData.append('offerName', offerData.offerName);
        formData.append('offerTagline', offerData.offerTagline);
        formData.append('offerImage', offerData.offerImage);
        formData.append('description', offerData.description);

        try {
            const response = await fetch('https://api.kcmstore.in/store/add-offer', {
                method: 'POST',
                body: formData
            });

            setLoading(false);
            if (response.ok) {
                setResponse('Offer added successfully!');
                setTimeout(() => {
                    setResponse('');
                    setShowOffer(false);
                    window.location.reload();
                }, 2000);
            } else if (response.status == 400) {
                setResponse('Cannot add more than 3 offers.');
                setLoading(false);
                setTimeout(() => {
                    setResponse('');
                }, 2000);
            }
        } catch (error) {
            console.error('Error adding offer:', error);
            setLoading(false);
        }
    };


    const showEditOfferDialog = (offer) => {
        setShowEditOffer(true);
        setSelectedOffer(offer);
        setOfferData({
            offerName: offer.offer_name,
            offerTagline: offer.offer_tagline,
            offerImage: null,
            description: offer.description
        })
    }


    const updateOfferSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        try {
            const formDataToSend = new FormData();
            Object.keys(offerData).forEach((key) => {
                formDataToSend.append(key, offerData[key]);
            });

            const response = await fetch(`https://api.kcmstore.in/store/update-offer/${selectedOffer.id}`, {
                method: 'PUT',
                body: formDataToSend
            });

            setLoading(false);
            if (response.ok) {
                const updatedProduct = await response.json();
                setResponse('Offer updated successfully!');
                setTimeout(() => {
                    setResponse('');
                    setShowEditOffer(false);
                    window.location.reload();
                }, 1000);
            } else {
                setResponse('Unable to update offer.');
                setLoading(false);
                setTimeout(() => {
                    setResponse('');
                }, 2000);
            }
        } catch (error) {
            setLoading(false);
            console.error('Error updating offer:', error);
        }
    }


    const indianStates = [
        "Andhra Pradesh", "Arunachal Pradesh", "Assam", "Bihar", "Chhattisgarh",
        "Goa", "Gujarat", "Haryana", "Himachal Pradesh", "Jharkhand", "Karnataka",
        "Kerala", "Madhya Pradesh", "Maharashtra", "Manipur", "Meghalaya", "Mizoram",
        "Nagaland", "Odisha", "Punjab", "Rajasthan", "Sikkim", "Tamil Nadu", "Telangana",
        "Tripura", "Uttar Pradesh", "Uttarakhand", "West Bengal", "Andaman and Nicobar Islands",
        "Chandigarh", "Dadra and Nagar Haveli and Daman and Diu", "Lakshadweep",
        "Delhi", "Puducherry"
    ];


    return (
        <>
            <section className='profile-area py-lg-5 py-md-5 py-4'>
                <div className='container-fluid px-4'>

                    <div className='row'>

                        <div className='col-lg-4 col-12 my-2'>
                            <div className='profile-left h-100'>

                                <div className='d-flex my-2'>
                                    <img src={ProfileImg} className='profile-img me-3' alt="Profile" />
                                    <div className='text-start'>
                                        <p className='featured-name'>{formData.name}</p>
                                        <p>{formData.location} {formData.city} {formData.state}</p></div>
                                </div>
                                {/* flex ends */}


                                <div className='text-start mt-4'>
                                    <p className='profile-text' onClick={() => { setShowProfile(true); setShowAddress(false); setShowManage(false); setShowPlatformFee(false) }}><i class="fa-solid me-3 fa-user"></i>Profile</p>
                                    <p className='profile-text' onClick={() => { setShowProfile(false); setShowAddress(true); setShowManage(false); setShowPlatformFee(false) }}><i class="fa-solid me-3 fa-address-card"></i>View Address</p>
                                    <p className='profile-text' onClick={() => { setShowProfile(false); setShowAddress(false); setShowManage(true); setShowPlatformFee(false) }}><i class="fa-solid me-3 fa-address-book"></i>Manage Profile</p>

{isAdmin && 
                                    <p className='profile-text' onClick={() => { setShowProfile(false); setShowAddress(false); setShowManage(false); setShowPlatformFee(true); }}><i class="fa-solid me-3 fa-credit-card"></i>Update Fee</p>}

                                </div>

                            </div>
                        </div>


                        <div className='col-lg-8 col-12 my-2'>
                            {showProfile && (
                                <>
                                    <div className='profile-left text-start'>
                                        <div className='d-flex'>
                                            <p className='sec-heading'>My Profile</p>
                                            <span className='sec-text animate__animated animate__flash animate__slow animate__infinite'>Details</span>
                                        </div>

                                        <div className="col-12 profile-left-area mb-4 mt-3">
                                            <label htmlFor="name" className="form-label fw-semibold">Name</label>
                                            <p className='my-0'>{formData.name || 'NA'}</p>
                                        </div>

                                        <div className="col-12 profile-left-area mb-4">
                                            <label htmlFor="name" className="form-label fw-semibold">Mobile Number</label>
                                            <p className='my-0'>{formData.phone || 'NA'}</p>
                                        </div>

                                        <div className="col-12 profile-left-area mb-4">
                                            <label htmlFor="name" className="form-label fw-semibold">Email Address</label>
                                            <p className='my-0'>{formData.email || 'NA'}</p>
                                        </div>

                                        <div className="col-12 profile-left-area mb-4">
                                            <label htmlFor="name" className="form-label fw-semibold">Gender</label>
                                            <p className='my-0'>{formData.gender || 'NA'}</p>
                                        </div>

                                        <div className="col-12 profile-left-area mb-4 d-flex justify-content-between">
                                            <div>
                                            <label htmlFor="name" className="form-label fw-semibold">Security Password</label>
                                            <p className='my-0'> {formData.pass
        ? showPass
          ? formData.pass
          : "••••••"
        : "NA"}</p></div>
                                                                              <button
  type="button"
  className="ms-2 btn p-1"
  onClick={() => setShowPass(!showPass)}
>
  <i className={`fa ${showPass ? "fa-eye-slash" : "fa-eye"}`}></i>
</button>
                                        </div>


                                    </div>
                                </>
                            )}


                            {showAddress && (
                                <>
                                    <div className='profile-left text-start'>
                                        <div className='d-flex'>
                                            <p className='sec-heading'>Address</p>
                                            <span className='sec-text animate__animated animate__flash animate__slow animate__infinite'>Details</span>
                                        </div>

                                        <div className="col-12 profile-left-area mb-4 mt-3">
                                            <label htmlFor="name" className="form-label fw-semibold">Address</label>
                                            <p className='my-0'>{formData.location || 'NA'}</p>
                                        </div>

                                        <div className="col-12 profile-left-area mb-4">
                                            <label htmlFor="name" className="form-label fw-semibold">City</label>
                                            <p className='my-0'>{formData.city || 'NA'}</p>
                                        </div>

                                        <div className="col-12 profile-left-area mb-4">
                                            <label htmlFor="name" className="form-label fw-semibold">State</label>
                                            <p className='my-0'>{formData.state || 'NA'}</p>
                                        </div>

                                        <div className="col-12 profile-left-area mb-4">
                                            <label htmlFor="name" className="form-label fw-semibold">Pincode</label>
                                            <p className='my-0'>{formData.pincode || 'NA'}</p>
                                        </div>


                                    </div>
                                </>
                            )}

                            {showManage && (
                                <>
                                    <div className='profile-left text-start'>
                                        <div className='d-flex'>
                                            <p className='sec-heading'>Update Profile</p>
                                            <span className='sec-text animate__animated animate__flash animate__slow animate__infinite'>Manage</span>
                                        </div>

                                        <form className="row g-3" onSubmit={handleSubmit}>
                                            <div className="col-12">
                                                <label htmlFor="name" className="form-label fw-semibold">Name</label>
                                                <input
                                                    type="text"
                                                    className="form-input"
                                                    id="name"
                                                    value={formData.name}
                                                    onChange={handleChange}
                                                />
                                            </div>
                                            <div className="col-md-6">
                                                <label htmlFor="phone" className="form-label fw-semibold">Mobile Number</label>
                                                <input
                                                    type="tel"
                                                    className="form-input"
                                                    id="phone"
                                                    value={formData.phone}
                                                    onChange={handleChange}
                                                />
                                            </div>
                                            <div className="col-md-6">
                                                <label htmlFor="email" className="form-label fw-semibold">Email</label>
                                                <input
                                                    type="email"
                                                    className="form-input"
                                                    id="email"
                                                    value={formData.email}
                                                    onChange={handleChange}
                                                />
                                            </div>
                                            <div className="col-12">
                                                <label htmlFor="gender" className="form-label fw-semibold">Gender</label>
                                                <select
                                                    className="form-input"
                                                    id="gender"
                                                    value={formData.gender}
                                                    onChange={handleChange}
                                                >
                                                    <option value="" disabled>Select Gender</option>
                                                    <option value="Male">Male</option>
                                                    <option value="Female">Female</option>
                                                    <option value="Other">Other</option>
                                                </select>
                                            </div>

                                            <div className="col-12">
                                                <label htmlFor="location" className="form-label fw-semibold">Address</label>
                                                <input
                                                    type="text"
                                                    className="form-input"
                                                    id="location"
                                                    value={formData.location}
                                                    onChange={handleChange}
                                                    required
                                                />
                                            </div>

                                            <div className="col-md-4">
                                                <label htmlFor="city" className="form-label fw-semibold">City</label>
                                                <input
                                                    type="text"
                                                    className="form-input"
                                                    id="city"
                                                    value={formData.city}
                                                    onChange={handleChange}
                                                    required
                                                />
                                            </div>

                                            <div className="col-md-4">
                                                <label htmlFor="state" className="form-label fw-semibold">State</label>
                                                <select
                                                    id="state"
                                                    className="form-input"
                                                    value={formData.state}
                                                    onChange={handleChange}
                                                    required
                                                >
                                                    <option value="" disabled>Select State</option>
                                                    {indianStates.map((state, index) => (
                                                        <option key={index} value={state}>
                                                            {state}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>


                                            <div className="col-md-4">
                                                <label htmlFor="pincode" className="form-label fw-semibold">Pincode</label>
                                                <input
                                                    type="text"
                                                    className="form-input"
                                                    id="pincode"
                                                    value={formData.pincode}
                                                    onChange={handleChange}
                                                    required
                                                />
                                            </div>

                                            <div className="col-12 text-end">
                                                <button type="submit" className="login-btn2">Update Profile</button>
                                            </div>
                                        </form>
                                    </div>
                                </>
                            )}


                            {showPlatformFee && (
                                <>
                                    <div className='profile-left text-start'>
                                        <div className='d-flex'>
                                            <p className='sec-heading'>Update Fee</p>
                                            <span className='sec-text animate__animated animate__flash animate__slow animate__infinite'>Orders</span>
                                        </div>

                                                <label className="form-label fw-semibold">App QR Code</label><br />
<img src={`https://api.kcmstore.in/sUploads/${userData.qr_code}`} className='w-auto mb-3' style={{ height: '12em'}} />

                                        <form className="row g-3" onSubmit={handleFeeSubmit}>

                                            <div className="col-12">
                                                <label htmlFor="platform_fee" className="form-label fw-semibold">Platform Fee</label>
                                                <input
                                                    type="text"
                                                    className="form-input"
                                                    id="platform_fee"
                                                    value={feeData.platform_fee}
                                                    onChange={handleFeeChange}
                                                />
                                            </div>

                                            <div className="col-12">
                                                <label htmlFor="delivery_fee" className="form-label fw-semibold">Delivery Charges</label>
                                                <input
                                                    type="text"
                                                    className="form-input"
                                                    id="delivery_fee"
                                                    value={feeData.delivery_fee}
                                                    onChange={handleFeeChange}
                                                />
                                            </div>

                                                                                        <div className="col-12">
                                                <label htmlFor="qrCode" className="form-label fw-semibold">New QR Code</label>
<input
  type="file"
  className="form-input bg-white"
  id="qrCode"
  onChange={(e) => {
    setFeeData({
      ...feeData,
      qrCode: e.target.files[0]
    });
  }}
/>
                                            </div>

                                            <div className="col-12 text-end my-4">
                                                <button type="submit" className="login-btn2">Update Changes</button>
                                            </div>
                                        </form>
                                    </div>
                                </>
                            )}
                        </div>

                    </div>
                    {/* row ends */}

                    {isAdmin && (
                        <>
                                                    <p className='sidebar-text' onClick={() => navigate('/add-delivery-agent')}><i class="fa-solid me-2 fa-truck-fast"></i>Delivery Agent</p>
                                                    <p className='sidebar-text' onClick={() => navigate('/delivery-history')}><i class="fa-solid me-2 fa-clock-rotate-left"></i>Orders Delivered</p>
                                                    <p className='sidebar-text' onClick={() => navigate('/exchange-history')}><i class="fa-solid me-2 fa-right-left"></i>Exchange Orders Delivered</p>
                            <p className='sidebar-text' onClick={() => navigate('/view-users')}><i class="fa-solid me-2 fa-users"></i>View Users</p>
                            <p className='sidebar-text' onClick={() => navigate('/manage-coupons')}><i class="fa-solid me-2 fa-tag"></i>Coupons</p>
                            <p className='sidebar-text' onClick={() => setShowOffer(true)}><i class="fa-solid me-2 fa-gift"></i>Add Promotions/ Offers</p>

                            <div className='row my-4'>
                                {offers.length > 0 ? (
                                    offers.map((offer, index) => {
                                        const offerUrl = `https://api.kcmstore.in/sUploads/${offer['image']}`;
                                        return (
                                            <div className='col-lg-6 my-2'>
                                                <p className='sidebar-text' onClick={() => showEditOfferDialog(offer)}> Offer {index + 1} <span className='float-end'>Edit this Offer <i class="fa-solid fa-dice"></i></span></p>
                                                <div className='rounded mt-2 text-light py-5' style={{ backgroundImage: `url(${offerUrl})`, backgroundPosition: 'center', backgroundSize: 'cover' }}>
                                                    <div className='container'>

                                                        <p className='fw-semibold'>{offer.offer_tagline}</p>
                                                        <p className='fs-4 fw-bold col-md-8'>{offer.offer_name}</p>
                                                        <p className='col-md-8 fw-semibold'>{offer.description}</p>
                                                    </div>
                                                </div>
                                            </div>
                                        )
                                    })
                                ) : (
                                    <> <p>No offers available</p>
                                    </>)}
                            </div>

                        </>
                    )}

                </div>
            </section>

            {showOffer && (
                <>
                    <section className='delete-dialog px-3'>
                        <div className='bg-white col-lg-5 col-md-8 mx-auto px-3 py-3 rounded-4' onClick={(e) => e.stopPropagation()}>

                            <form className="g-3 bg-white text-start mt-4" onSubmit={handleOfferSubmit}>
                                {/* Product Name */}
                                <div className="col-12">
                                    <label htmlFor="productName" className="form-label fw-semibold">Offer Name</label>
                                    <input
                                        type="text"
                                        className="form-input"
                                        id="offerName"
                                        value={offerData.offerName}
                                        onChange={handleOfferChange}
                                        required
                                    />
                                </div>

                                {/* Tagline */}
                                <div className="col-12">
                                    <label htmlFor="productTagline" className="form-label fw-semibold">Offer Tagline</label>
                                    <input
                                        type="text"
                                        className="form-input"
                                        id="offerTagline"
                                        value={offerData.offerTagline}
                                        onChange={handleOfferChange}
                                        required
                                    />
                                </div>

                                {/* Image Upload */}
                                <div className="col-12">
                                    <label htmlFor="image" className="form-label fw-semibold">Upload Image</label>
                                    <input
                                        type="file"
                                        className="form-input bg-white"
                                        id="offerImage"
                                        onChange={handleOfferChange}
                                        required
                                    />
                                </div>

                                {/* description */}
                                <div className="col-12">
                                    <label htmlFor="Description" className="form-label fw-semibold">Description</label>
                                    <textarea
                                        type="text"
                                        className="form-input"
                                        id="description"
                                        style={{ height: '6em' }}
                                        value={offerData.description}
                                        onChange={handleOfferChange}
                                        required></textarea>
                                </div>

                                {/* Submit Button */}
                                <div className="col-12 text-end mt-3">
                                    <button className='danger-btn' onClick={() => setShowOffer(false)}>Cancel</button>&nbsp;&nbsp;
                                    <button className='success-btn'>Add Offer</button>
                                </div>
                            </form>


                        </div>
                    </section>
                </>
            )}


            {showEditOffer && (
                <>
                    <section className='delete-dialog px-3'>
                        <div className='bg-white col-lg-5 col-md-8 mx-auto px-3 py-3 rounded-4' onClick={(e) => e.stopPropagation()}>

                            <form className="g-3 bg-white text-start mt-4" onSubmit={updateOfferSubmit}>
                                {/* Product Name */}
                                <div className="col-12">
                                    <label htmlFor="productName" className="form-label fw-semibold">Offer Name</label>
                                    <input
                                        type="text"
                                        className="form-input"
                                        id="offerName"
                                        value={offerData.offerName}
                                        onChange={handleOfferChange}
                                    />
                                </div>

                                {/* Tagline */}
                                <div className="col-12">
                                    <label htmlFor="productTagline" className="form-label fw-semibold">Offer Tagline</label>
                                    <input
                                        type="text"
                                        className="form-input"
                                        id="offerTagline"
                                        value={offerData.offerTagline}
                                        onChange={handleOfferChange}
                                    />
                                </div>

                                {/* Image Upload */}
                                <div className="col-12">
                                    <label htmlFor="image" className="form-label fw-semibold">Upload Image</label>
                                    <input
                                        type="file"
                                        className="form-input bg-white"
                                        id="offerImage"
                                        onChange={handleOfferChange}
                                    />
                                </div>

                                {/* description */}
                                <div className="col-12">
                                    <label htmlFor="Description" className="form-label fw-semibold">Description</label>
                                    <textarea
                                        type="text"
                                        className="form-input"
                                        id="description"
                                        style={{ height: '6em' }}
                                        value={offerData.description}
                                        onChange={handleOfferChange}></textarea>
                                </div>

                                {/* Submit Button */}
                                <div className="col-12 text-end mt-3">
                                    <button className='danger-btn' onClick={() => setShowEditOffer(false)}>Cancel</button>&nbsp;&nbsp;
                                    <button className='success-btn'>Update Offer</button>
                                </div>
                            </form>


                        </div>
                    </section>
                </>
            )}

            {response && <ResponseMsg message={response} />}
            {loading && <Loading setLoading={setLoading} />}
        </>
    );
}

export default Profile;
